module.exports = ( $scope, $uibModalInstance, request, messages ) ->

  $scope.close = ->
    $uibModalInstance.dismiss 'close'
    return

  $scope.request  = request
  $scope.messages = messages
